// Auto-generated by scripts/generateBuildInfo.mjs — do not edit manually.

/** Short commit hash identifying the build that produced this bundle. */
export const BUILD_IDENTIFIER = '97411c0';
